<template>
  <div :class="active ? 'menu' : 'menu noactive'">
    <div class="zoom" @click="zoom" :style="active?'':'transform:translateY(-50%) rotate(180deg);'">
      <img src="@/assets/images/zx.png" alt="">
    </div>
    <div class="menutitle" :style="active?'':'opacity:0'">{{ title }}</div>
    <div :class="active ? 'returnpage' : 'returnpage notext'" v-if="isreturn" @click="toctl"><img
        src="../assets/images/return.png" alt=""> <span v-show="active">返回工作台</span></div>
    <div class="menubody custom-scrollbar">
      <div v-for="(item, index) in menulist" :key="index" :class="menuIndex2 === index ? 'menuitem select' : 'menuitem'"
        @click="changeIndex(index)">
        <el-tooltip v-show="!active" class="item" effect="dark" :content="item.text" placement="right">
          <img :src="menuIndex2 === index ? item.img2 : item.img1" :alt="item.text">
        </el-tooltip>
        <span v-show="active"><img :src="menuIndex2 === index ? item.img2 : item.img1" :alt="item.text">{{ item.text
        }}</span>
      </div>
    </div>
    <!-- <div class="menubottom">项目协作管理系统</div> -->

  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: '',
  // 1. 外部传入的 props 数据（menulist 必传）
  props: {
    title: {
      type: String,
      required: true

    },
    menulist: {
      type: Array,
      required: true
    },
    isreturn: {
      type: Boolean,
      default: false
    },
    menuIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      active: true,
      menuIndex2: 0,
      status: 'activate' // 组件内部状态（可根据业务扩展，如 'active'/'disabled' 等）
    }
  },
  created () {
    this.menuIndex2 = this.menuIndex
    // 监听全局事件，用于更新active值
    this.$bus.$on('menu-active', (newActiveValue) => {
      // 接收外部传递的新值并更新active
      this.active = newActiveValue
    })
  },
  watch:{
    menuIndex(){
      this.menuIndex2 = this.menuIndex
    }
  },
  beforeDestroy () {
    // 组件销毁前移除事件监听，防止内存泄漏
    this.$bus.$off('menu-active')
  },
  methods: {
    changeIndex (index) {
      // 更新内部选中索引
      // this.$message.warning('开发中')
      if (index == 5 || index == 6) {

      } else {
        this.menuIndex2 = index
      }
      // 触发外部事件，向父组件传递选中的索引和数据
      this.$emit('menu-click', {
        index: index,
        selectedItem: this.menulist[index]
      })
    },
    zoom () {
      this.active = !this.active
    },
    // 4. 内部状态更新方法（可根据业务逻辑调整）
    updateStatus (activeIndex) {
      // 示例逻辑：选中第一个菜单时状态为 'active'，其他为 'normal'
      this.status = activeIndex === 0 ? 'active' : 'normal'
      // 触发内部状态变更的事件（供父组件监听状态变化）
      this.$emit('status-change', this.status)
    },
    toctl () {
      // this.$router.push('/main/index')
       this.$router.push('/space')
    }
  }
}
</script>
<style lang="scss" scoped>
/* 菜单 */

.menu {
  z-index: 9;
  height: 100%;
  width: 250px;
  background: #F8F8F8;
  border-radius: 0px 0px 0px 0px;
  padding: 28px;
  padding-bottom: 80px;
  position: relative;
  border-right: 1px solid #e6e6e6;
  transition: all .2s linear;
  .zoom{
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    line-height: 20px;
    text-align: center;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #e6e6e6;
    background-color: #fff;
    img{
      width: 10px;
      transform: translateY(-2px);
    }
  }
  .returnpage {
    margin-top: 10px;
    width: 134px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #DDDDDD;
    text-align: center;
    line-height: 36px;
    cursor: pointer;

    img {
      width: 20px;
      // margin-right: 4px;
      transform: translateY(-2px);
    }
  }

  .menutitle {
    font-weight: bold;
    font-size: 30px;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    color: #262626;
  }

  .menubody {
    width: 100%;
    margin-top: 30px;
    overflow-y: auto;
    height: 83vh;

    .menuitem {
      cursor: pointer;
      height: 48px;
      line-height: 48px;
      width: 100%;
      padding-left: 10px;
      // text-align: center;
      border-radius: 8px 8px 8px 8px;
      color: #595959;
      font-size: 18px;
      margin-bottom: 10px;
      overflow: hidden;
      img {
        width: 24px;
        margin-right: 6px;
        transform: translateY(-2px);
      }
    }

    .select {
      background: linear-gradient(90deg, #66AFFF 0%, #046CF3 100%), #046DFA;
      color: white;

    }
  }

  .menubottom {
    position: absolute;
    bottom: 30px;
    width: 100%;
    left: 0;
    font-size: 16px;
    color: #8C8C8C;
    text-align: center;
  }
}

.noactive {
  width: 100px;
}

.notext {
  width: 50px !important;
}
</style>
